export default {
  hint: {
    next: 'NEXT',
    previous: 'PREVIOUS',
    done: 'DONE'
  }
}
